import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';
import { apiAction as getBusinessesApiAction } from './getBusinesses';

const actions = createActions({
  ADMIN: {
    CHANGE_BUSINESS_INDUSTRY: (businessId, industryId) => ({ businessId, industryId }),
    API: {
      CHANGE_BUSINESS_INDUSTRY: apiResourceActionCreator('businessIndustry')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/change-business-industry/${payload.businessId}/${payload.industryId}`, authToken, {}, actions.admin.api.changeBusinessIndustry);

function* changeBusinessIndustry(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));

  const result = yield apiActionResult(actions.admin.api.changeBusinessIndustry);

  if (result.success) {
    yield put(getBusinessesApiAction(authToken));
  }
}

const configuration = {
  name: 'changeBusinessIndustry',
  action: actions,
  sagas: changeBusinessIndustry,
  reducers: {
    request: (state, action) => ({
      ...state,
      isChangingIndustry: true,
      error: null
    }),
    success: (state, action) => ({
      ...state,
      isChangingIndustry: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isChangingIndustry: false,
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/changeBusinessIndustry.js